import React from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { closeDeleteModal } from "../../pages/Survey/Survey.slice";

const ConfirmDeleteModal = () => {
  const dispatch = useDispatch();
  const { isOpen, onConfirm } = useSelector(
    (state) => state.survey.deleteModal
  );

  const handleClose = () => {
    dispatch(closeDeleteModal());
  };

  const handleConfirm = () => {
    if (onConfirm) onConfirm();
    handleClose();
  };

  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <DialogContent>
        <Typography>
          Answer records exist for this item. Click Continue to delete the item
          and all associated answers, as well as any associated rules.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={handleClose}>
          Cancel
        </Button>
        <Button onClick={handleConfirm} color="primary" variant="contained">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteModal;
